/* istanbul ignore file */
import { styled } from '@mui/material/styles';

import { px, rem, Theme } from '../../theme';

interface StyledMainProperties {
    $hasSnackBar?: boolean;
    $appBannerVisible?: boolean;
    $isMobileSession?: boolean;
    $isMobileApp?: boolean;
    theme: Theme;
}

export const StyledMain = styled('main')<StyledMainProperties>`
    ${({
        theme,
        $appBannerVisible,
        $hasSnackBar,
        $isMobileApp,
        $isMobileSession,
    }: StyledMainProperties) => `
        padding-top: ${$appBannerVisible ? theme.tggSpacing(px(55), 13.75) : theme.tggSpacing(0, 0)};
        margin-top: ${$hasSnackBar ? theme.tggSpacing(rem(9.4), 23.5) : $isMobileSession ? theme.tggSpacing(0, 0) : theme.tggSpacing(rem(6), 15)};

        ${theme.breakpoints.up('desktop')} {
            margin-top: ${
                $hasSnackBar
                    ? theme.tggSpacing(rem(11.6), 29)
                    : $isMobileSession
                      ? theme.tggSpacing(0, 0)
                      : theme.tggSpacing(rem(7.2), 18)
            };
        }
	`}
`;
